import React  from 'react';
import { EditGuesser, InputGuesser } from "@api-platform/admin";
import { BooleanInput, ReferenceInput, SelectInput, AutocompleteInput } from 'react-admin';

const StepEdit = (props) => (
  <EditGuesser {...props}>
    <InputGuesser source="name" />
    <InputGuesser source="categoryName" />
    <InputGuesser source="title" />
    <BooleanInput defaultValue={false} source="upsell" />
    <BooleanInput defaultValue={false} source="required" />
    <BooleanInput defaultValue={false} source="enabled" />
    <InputGuesser source="descriptionRequired" />
    <ReferenceInput
      label="Step Type"
      source="stepType"
      reference="step_types"
      perPage={1900}
    >
      <AutocompleteInput optionText="name" />
    </ReferenceInput>
    <ReferenceInput label="Language" source="language" reference="languages">
      <SelectInput optionText="name" />
    </ReferenceInput>
  </EditGuesser>
  );

export default StepEdit;